import GeneralHome from "./Componentes/GeneralHome";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CurriculumDev from "./Componentes/c.vitae/CurriculumDev";

function App() {
  const backGround = {
    background: "rgb(0,0,0)",
    background:
      "linear-gradient(90deg, rgba(0,0,0,1) 45%, rgba(41,41,43,1) 93%)",
    color: "rgb(202,202,202)",
  };

  return (
    <BrowserRouter>
      <div className="App" style={backGround}>
        <Routes>
          <Route exact path="/miguelfiguera/" Component={GeneralHome} />
          <Route exact path="/miguelfiguera/dev" Component={CurriculumDev} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
